'use strict';
const _ = require('underscore'),
	observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function MeasuresActivatedNodesFilter(mapModel) {
	let ids = [];
	const self = observable(this),
		storeIds = function (newIds) {
			ids = (newIds && newIds.slice && newIds.slice(0))  || [];
		},
		onFilteredResultsChange = function (force) {
			const newIds = mapModel.getActivatedNodeIds();

			if (force || !_.isEqual(ids, newIds)) {
				storeIds(newIds);
				self.dispatchEvent('filteredRowsChanged');
			}
		},
		onFilteredResultsChangeForced = onFilteredResultsChange.bind(self, true);
	storeIds(mapModel.getActivatedNodeIds());
	mapModel.addEventListener('activatedNodesChanged', onFilteredResultsChange);
	mapModel.addEventListener('nodeTitleChanged', onFilteredResultsChangeForced);
	self.predicate = function (idea) {
		return idea && _.include(ids, idea.id);
	};
	self.cleanup = function () {
		mapModel.removeEventListener('activatedNodesChanged', onFilteredResultsChange);
		mapModel.removeEventListener('nodeTitleChanged', onFilteredResultsChangeForced);
	};
};
